import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { PrivateRoute, PublicRoute } from ".";
import { ThisPaths } from "../shared/Constants";

// Pages
import DiningRoom from "../pages/DiningRoom/DiningRoom";
import ForgotPassword from "../pages/UserSession/ForgotPassword";
import Login from "../pages/UserSession/Login";

import Navbar from "../components/Header/NavBar";
import Footer from "../components/Footer";
import HistoryPage from "../pages/History/HistoryPage";
import ActivateAccount from "../pages/UserSession/ActivateAccount";
import ChangePassword from "../pages/UserSession/ChangePassword";

function AppRoutes() {
    return (
        <Router>
            <Navbar />
            <Switch>
                <PublicRoute path={ThisPaths.LOGIN} component={Login} />
                <PublicRoute
                    path={ThisPaths.ACTIVATE_ACCOUNT}
                    component={ActivateAccount}
                />
                <PublicRoute
                    path={ThisPaths.FORGOT_PASSWORD}
                    component={ForgotPassword}
                />
                <PrivateRoute
                    exact
                    path={ThisPaths.CHANGE_PASSWORD}
                    component={ChangePassword}
                />
                <PrivateRoute
                    exact
                    path={ThisPaths.MENU}
                    component={DiningRoom}
                />
                <PrivateRoute
                    exact
                    path={ThisPaths.HISTORY}
                    component={HistoryPage}
                />

                <Redirect to={ThisPaths.LOGIN} />
            </Switch>
            <Footer />
        </Router>
    );
}

export default AppRoutes;
